const ROOTS = {
  FINANCIAL: '/financial',
  AUTH: '',
};

// ----------------------------------------------------------------------

export const paths = {
  financial: {
    root: ROOTS.FINANCIAL,
    flow: `${ROOTS.FINANCIAL}/flow`,
    balance: `${ROOTS.FINANCIAL}/balance`,
    insights: `${ROOTS.FINANCIAL}/insights`,
    profile: `${ROOTS.FINANCIAL}/profile`,
    details: `${ROOTS.FINANCIAL}/details`,
    consuming: `${ROOTS.FINANCIAL}/consuming-analitics`,
    credit: `${ROOTS.FINANCIAL}/credit-profile`,
  },
  auth: {
    login: `${ROOTS.AUTH}/`,
    signup: `${ROOTS.AUTH}/signup`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    newPassword: `${ROOTS.AUTH}/new-password`,
    sendPassword: `${ROOTS.AUTH}/send-password`,
  },
  page404: '/404',
};
